import React from 'react';
import { EditableDataGrid } from '../../../../builderPackage/components/editableDataGrid/editableDataGrid';
var closeIRPoupCatalog = function (props) {
    var onChange = props.onChange, value = props.value, error = props.error, name = props.name;
    var columns = [{
            field: 'IR no.',
            headerName: 'IR no.',
            headerAlign: 'center',
            minWidth: 100
        }, {
            field: 'CQA remarks',
            headerName: 'CQA remarks',
            minWidth: 150,
            flex: 1,
            editable: true
        }, {
            type: 'dateTime',
            field: 'Date & time',
            headerName: 'Tentative closure date',
            minWidth: 150,
            flex: 1,
            editable: true
        }, {
            field: 'Action',
            headerName: 'Action',
            flex: 1
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        onChange: onChange,
        disableToolbarActions: true,
        getToolbarActions: function (params) { return []; },
        dataGridHeaderProps: {},
        dataGridProps: {
            hideFooter: true
        },
        rows: [{
                id: 1,
                'FFR number.': 'FFR123456',
                'Action': 'Accept'
            }, {
                id: 2,
                'FFR number.': 'FFR654321',
                'Action': 'Accept'
            }]
    }));
};
export default closeIRPoupCatalog;
